
import { defineComponent, onMounted } from "vue";
import { translate } from "@/core/services/HelpersFun";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
export default defineComponent({
  name: "kt-services-information",
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs(
        translate("Introduction of Inboxino services"),
        []
      );
    });
    return {
      translate,
    };
  },
});
